import React from 'react'
import { TAbstractCatalogConfig } from '../../../models/AbstractCatalogConfig'
import { TExtraFieldValue } from '../../../models/ExtraField'
import { ExtraFieldFormValuesText } from './extraFieldFormValues/Text'
import { ExtraFieldFormValuesTextarea } from './extraFieldFormValues/Textarea'
import { ExtraFieldFormValuesCheckbox } from './extraFieldFormValues/Checkbox'
import { ExtraFieldFormValuesCatalog } from './extraFieldFormValues/Catalog'

interface Props {
  config: TAbstractCatalogConfig
  fields: TExtraFieldValue[]
}

export const ExtraFieldFormValues = ({ config, fields }: Props) => {
  const fieldMap = new Map(fields.map(i => [i.fieldID, i]))

  return (
    <>
      {config.fields.map(fieldConfig => {
        const idx = fields.findIndex(i => i.fieldID === fieldConfig.id)
        if (idx === -1) { return }

        if (fieldConfig.fieldType === 'TEXT') {
          return (
            <ExtraFieldFormValuesText
              key={fieldConfig.id}
              idx={idx}
              fieldConfig={fieldConfig}
              fieldValue={fields[idx]}
            />
          )
        }

        if (fieldConfig.fieldType === 'TEXTAREA') {
          return (
            <ExtraFieldFormValuesTextarea
              key={fieldConfig.id}
              idx={idx}
              fieldConfig={fieldConfig}
              fieldValue={fields[idx]}
            />
          )
        }

        if (fieldConfig.fieldType === 'CHECKBOX') {
          return (
            <ExtraFieldFormValuesCheckbox
              key={fieldConfig.id}
              idx={idx}
              fieldConfig={fieldConfig}
              fieldValue={fields[idx]}
            />
          )
        }

        if (fieldConfig.fieldType === 'CATALOG') {
          return (
            <ExtraFieldFormValuesCatalog
              key={fieldConfig.id}
              idx={idx}
              fieldConfig={fieldConfig}
              fieldValue={fields[idx]}
            />
          )
        }
      })}
    </>
  )
}

const requiredRules = [{ required: true }]
